import ComponentModule from 'lib/component-module';
import tabs from 'lib/tabs';
import {
    contentApplications as contentApplicationsTemplate,
} from 'lib/template-strings/solution-area';
import { applicationsModal } from "../modals";
import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import store from "../store";

Vue.use(VModal);

ComponentModule.AddModule('.solution-area', {
    prefix: 'solution-area-',
    components: [
        tabs({
            data: function() {
                return {
                    isMobile: null,
                    store: store
                }
            },
            watch: {
                isMobile: function() {
                    if (!this.isMobile) {
                        this.$modal.hide('applications');
                    }
                }
            },
            methods: {
                changeTab: function(id){
                    if (this.currentTab != id) {
                        this.currentTab = id;
                        this.$nextTick(() => {
                            this.scrollToTop();
                        })
                    } else {
                        // close tab if clicked again
                        if(this.isMobile) {
                            this.currentTab = null;
                        }
                    }
                },
                showModal() {
                    const apps = document.querySelector('.solution-area__applications-item.active').cloneNode(true);
                    console.log(applicationsModal.name);
                    this.$modal.show(
                        applicationsModal.template,
                        applicationsModal.name,
                        applicationsModal.options,
                        applicationsModal.events(apps)
                    )
                },
                hideApplications : function () {
                    this.$modal.hide('applications');
                },
                checkIsMobile() {
                    // this is checking for a breakpoint *smaller* than
                    // var isMobile in store.js
                    var mql = window.matchMedia('(max-width: 650px)');
                    this.isMobile = mql.matches ? true : false;
        
                    mql.addEventListener('change',() => {
                        this.isMobile = mql.matches ? true : false;
                    });
                },
                scrollToTop() {
                    let el = this.$el.querySelector('.solution-area__content-item.active');
                    let elmOffset = el.offsetTop;
                    let scrollOffset = window.scrollY;
                    // console.log("el",elmOffset);
                    // console.log("window",scrollOffset);
                    if (elmOffset < scrollOffset) {
                        let elmPos = el.getBoundingClientRect().top + window.scrollY;
                        setTimeout(function() {
                            window.scrollTo({
                                top: (elmPos - 70),
                                behavior: 'smooth'
                            });
                        },500);
                    }
                },
            },
            components: {
                'applications-content': {
                    name: 'applications-content',
                    template: contentApplicationsTemplate,
                    props: {
                        idTab: [String, Number],
                        currentTab: [String, Number],
                        activeClass: {type: String, default: 'active'},
                        close: Function
                    },
                    data: function() {
                        return {
                            label: null
                        }
                    },
                    computed: {
                        taggingMeta: function() {
                            return JSON.stringify({
                                "type": "layer", //static 
                                "category": "Drawer", //static
                                "action": "Open", // static
                                "label": this.label, // Tab label e.g. District system balancing
                                "no": this.idTab < 10 ? `0${this.idTab}` : `${this.idTab}`
                            })
                        }
                    },
                    mounted() {
                        this.label = Array.prototype.slice.call(document.querySelectorAll('.solution-area__tabs li'))[(this.idTab - 1)].innerText;
                    }
                },
            },
            tabData: {
                label: null
            },
            tabOptions: {
                computed: {
                    taggingMeta: function() {
                        return JSON.stringify({
                            "type": "layer", //static 
                            "category": "Drawer", //static
                            "action": "Open", // static
                            "label": this.label, // Tab label e.g. District system balancing
                            "no": this.idTab < 10 ? `0${this.idTab}` : `${this.idTab}`
                        })
                    }
                },
                mounted() {
                    this.label = this.$el.innerText;
                }
            },
            tabContentData: {
                label: null
            },
            tabContentOptions: {
                computed: {
                    taggingMeta: function() {
                        return JSON.stringify({
                            "type": "layer", //static 
                            "category": "Drawer", //static
                            "action": "Open", // static
                            "label": this.label, // Tab label e.g. District system balancing
                            "no": this.idTab < 10 ? `0${this.idTab}` : `${this.idTab}`
                        })
                    }
                },
                mounted() {
                    this.label = Array.prototype.slice.call(document.querySelectorAll('.solution-area__tabs li'))[(this.idTab - 1)].innerText;
                }
            },
            mounted() {
                this.checkIsMobile();
            }
        })
    ]
});
